import React from 'react';
import { Badge, Label } from '@nooz-optics/nooz-components-lib';
import { BannerButtons } from '..';
import { TrustpilotHorizontalReviews } from '../../Reviews/Trustpilot/trustpilotHorizontalReviews';
import clsx from 'clsx';

export const TextWithLine = ({ label, color }) => (
  <div className='w-full lg:px-10'>
    <div
      className={`w-full h-full flex justify-start border-t border-${color?.classname} py-6 pb-12`}
    >
      <Label {...label} color={color} />
    </div>
  </div>
);

export const TextWithLineBanner = ({ label }) => (
  <div id='text-with-line-banner' className='w-full h-full text-white lg:px-16'>
    <TextWithLine
      label={{ ...label, size: '7xl' }}
      color={{ classname: 'white' }}
    />
  </div>
);

export const TextBanner = ({
  label,
  body,
  placement,
  buttons,
  badges,
  hasTrustpilot,
  children,
  textContainerAlignment = 'items-center',
  isVerticallyCenter,
}) => {
  return (
    <div
      className={clsx(
        `main-wrapper absolute top-0 lg:relative flex h-full`,
        textContainerAlignment,
        'w-full',
        isVerticallyCenter && 'items-center'
      )}
    >
      {isVerticallyCenter || placement === 'right' ? (
        <div className='flex-1 hidden lg:block' />
      ) : null}
      <div
        className={clsx(
          'h-3/4 lg:h-2/3 flex justify-between lg:justify-center flex-col',
          isVerticallyCenter ? 'w-1/2' : 'flex-1'
        )}
      >
        <div
          className={clsx(
            `flex items-start text-${
              isVerticallyCenter ? 'center' : 'left'
            } justify-center flex-col`
          )}
        >
          <div
            className={clsx(
              'mb-4 flex w-11/12',
              isVerticallyCenter && 'justify-center w-full'
            )}
          >
            {badges?.items.map((badge, key) => (
              <div className={clsx(key > 0 && 'ml-2')}>
                <Badge {...badge} />
              </div>
            ))}
          </div>
          <div
            className={clsx('mb-4', isVerticallyCenter ? 'w-full' : 'w-11/12')}
          >
            <Label
              {...label}
              size='5xl'
              weight='medium'
              align={isVerticallyCenter ? 'text-center' : undefined}
              color={label.color || { classname: 'white' }}
            />
          </div>
          <div className='mb-6'>
            <Label
              {...body}
              weight='light'
              family='font-inter'
              size='xl'
              align={isVerticallyCenter ? 'text-center' : undefined}
              color={{ classname: 'white' }}
            />
          </div>
          {children}
        </div>
        <div
          className={`w-full flex ${
            isVerticallyCenter ? 'justify-center' : 'justify-start'
          }`}
        >
          <BannerButtons buttons={buttons} size='lg' />
        </div>
        {hasTrustpilot && (
          <div className='absolute inset-x-0 bottom-4'>
            <TrustpilotHorizontalReviews />
          </div>
        )}
      </div>
      {isVerticallyCenter || placement === 'left' ? (
        <div className='flex-1 hidden lg:block' />
      ) : null}
    </div>
  );
};
